export default function Hero() {
  return (
    <section id="top" className="relative flex h-[560px] w-full items-center justify-center overflow-hidden md:h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20dark%20webtoon%20manhwa%20art%20collage%20with%20ink%20sketch%20characters%20silhouettes%2C%20glowing%20amber%20crescent%20moon%20and%20starlight%20particles%2C%20cinematic%20wide%20composition%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20immersive%20editorial%20backdrop%2C%20high%20detail&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫在线阅读平台氛围背景"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 flex w-full max-w-3xl flex-col items-center px-4 text-center md:px-6">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur-sm">
          <i className="ri-sparkling-2-line text-primary-400"></i>
          韩漫在线 · 无弹窗高清阅读平台
        </span>
        <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          沉浸式韩漫阅读体验
          <span className="block text-primary-400">从这里开始</span>
        </h1>
        <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
          无弹窗干扰、高清画质极速加载，翻页缩放顺手自如。无论极速浏览还是细细品味，韩漫在线的完整阅读功能都能满足你。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#showcase"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
          >
            立即开始阅读
          </a>
          <a
            href="#reader"
            className="whitespace-nowrap rounded-full border border-background-50/40 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
          >
            体验阅读器
          </a>
        </div>
        <div className="mt-10 flex items-center gap-6 text-background-50">
          {[
            ["1200+", "连载韩漫"],
            ["98%", "无弹窗纯净"],
            ["24h", "持续更新"],
          ].map(([num, label]) => (
            <div key={label} className="text-center">
              <div className="font-heading text-2xl font-bold text-primary-400 md:text-3xl">{num}</div>
              <div className="mt-1 text-xs text-background-100">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}